import Layout from '@4c/layout';
import FailureIcon from '@bfly/icons/Failure';
import SuccessIcon from '@bfly/icons/Success';

import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from './Button';
const styles = require('./Toast-styles.module.scss');
const SUCCESS_ICON = React.createElement(SuccessIcon, {
  className: styles.success
});
const FAILURE_ICON = React.createElement(FailureIcon, {
  className: styles.failure
});
const LEVEL_TO_ICON = {
  info: SUCCESS_ICON,
  success: SUCCESS_ICON,
  error: FAILURE_ICON,
  warning: FAILURE_ICON
};

function Toast({
  toast,
  dismissAfter
}) {
  function onDismiss() {
    toast.dismiss();
  }

  useEffect(() => {
    if (dismissAfter == null) {
      return undefined;
    }

    const dismissHandle = setTimeout(onDismiss, dismissAfter);
    return () => {
      clearTimeout(dismissHandle);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onDismiss, toast]);
  const {
    level,
    message
  } = toast;
  return React.createElement(Layout, {
    role: "presentation",
    align: "center",
    pad: true,
    onClick: onDismiss,
    className: styles.toast,
    "data-bni-id": "Toast"
  }, LEVEL_TO_ICON[level], React.createElement(Layout, {
    grow: true
  }, message), React.createElement(Button, {
    className: styles.dismissButton,
    theme: "link"
  }, React.createElement(FormattedMessage, {
    id: "@bfly/ui:toast.dismiss",
    defaultMessage: "Dismiss"
  })));
}

export default Toast;